module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACKSURBVHgB7ZSNCYAgFISPJrlRG6ENG8E2MASFev7kU4SwPngoqHeKp8DX2H0Nw/qqZsFgfoN3G4RIsjCH6IiuW2SFyTWmFHPUMGESDFJjTVAIWdHvEk+ZWGFChU7xsoj4BNTqPP0zRF2ysjrqj6zGYK6XfPiWaIdC68aKOIqttSGDGzAdwsZvdCJO/ypcWQKPxAsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ui/download.png
// module id = kfcg
// module chunks = 1